import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Register } from '@xanadu/core';
import { Content, ContentField, Genus } from '@xanadu/model';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('content')
export class ContentComponent {
    tags = input<{key: string, value: ContentField[]}[]>();
    custome = input<any>();
    formGroup = input<FormGroup>();
    node = input<Content | Genus>();
    readonly = input<boolean>(false);
}
